import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { getCollectionCardItems } from 'features/kyrgyzstan/select-collection-item'
import { useSelectCollectionItem } from 'features/kyrgyzstan/select-collection-item/lib'

import { kyrgyzstanCollectionsStore } from 'entities/kyrgyzstan/model'
import { CollectionsGridLayout } from 'entities/kyrgyzstan/ui'

import { HeaderGoBack } from 'shared/ui/header-go-back'

import s from './styles.module.scss'

const KyrgyzstanCollectionsPage = observer(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()

  useEffect(() => {
    kyrgyzstanCollectionsStore.loadIfNeeded()
  }, [])

  const collection = id
    ? kyrgyzstanCollectionsStore.getCollectionById(id)
    : undefined
  const title = collection?.title || t('kyrgyzstan_block.collections.title')
  const { isLoading } = kyrgyzstanCollectionsStore
  const preparedItems = collection ? getCollectionCardItems(collection) : []

  const { selectCollectionItem } = useSelectCollectionItem()

  return (
    <div className={s.container}>
      <HeaderGoBack
        title={title}
        onGoBack={() => navigate(-1)}
        buttonWhite
      />

      <div className={clsx('container', s.list)}>
        <CollectionsGridLayout
          items={preparedItems}
          isLoading={isLoading}
          onSelectItem={(item) => selectCollectionItem(item)}
        />
      </div>
    </div>
  )
})

export default KyrgyzstanCollectionsPage
